import { useQuery } from '@apollo/client';
import React from 'react';
import Activities from '../activities/Activities';
import ConnectionHelper from '../utils/graphql/ConnectionHelper';
import nonEmpty from '../utils/nonEmpty';
import { gql } from '../graphql/generated/gql';

const ACTIVITIES_QUERY = gql(`
  query activities($afterCursor: String) {
    activities(first: 10, after: $afterCursor) {
      edges {
        node {
          ...Activities_activities
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`);

const HomeActivities = () => {
  const response = useQuery(ACTIVITIES_QUERY);

  const { data } = response;
  const fetchMore = ConnectionHelper.generateFetchMore(
    ACTIVITIES_QUERY,
    response,
    'activities',
  );

  return data?.activities?.edges ? (
    <Activities
      activities={data.activities.edges
        .map((edge) => edge?.node)
        .filter(nonEmpty)}
      fetchMore={fetchMore}
    />
  ) : null;
};

export default HomeActivities;
